import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

function ImagePreviewModal({ openModal, handleClose, image }) {
  useEffect(() => {}, []);

  return (
    <Modal show={openModal} onHide={handleClose}>
      <Modal.Body>
        <div className="d-flex justify-content-end">
          <button
            style={{ border: "1px solid grey", borderRadius: "30px" }}
            type="button"
            className="btn-close"
            onClick={handleClose}
          ></button>
        </div>
        <div
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ height: "50vh" }}
        >
          <img
            src={image}
            alt="image"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ImagePreviewModal;
